module.exports = __webpack_public_path__ + "img/horizontal_6_7_9005.a6d25be4.png";